<script setup lang="ts">
// @ts-nocheck

import {label} from "../mixins/translations";
import {TooltipProvider} from "reka-ui";
import Tooltip from "../../backend/ui/tooltip/Tooltip.vue";

interface Props {
    loginUrl: string,
}

defineProps<Props>()

</script>

<template>
    <TooltipProvider delay-duration="200">
        <Tooltip :content="label('site.account.header.title')">
            <a :href="loginUrl" class="relative flex rounded-lg h-9 w-9 lg:h-12 lg:w-12 justify-center items-center hover:border border-gray-200">
                <svg class="h-6 w-6 lg:h-7 lg:w-7" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
            </a>
        </Tooltip>
    </TooltipProvider>
</template>
